import { render } from "./InsertModal.vue?vue&type=template&id=1504c1de&scoped=true"
import script from "./InsertModal.vue?vue&type=script&lang=js"
export * from "./InsertModal.vue?vue&type=script&lang=js"

import "./InsertModal.vue?vue&type=style&index=0&id=1504c1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1504c1de"]])

export default __exports__